import React from 'react';
import { CustomRedirect, CustomNavLink } from './base';
import { prefixTo } from './helpers';
import { connect, DispatchProp } from 'react-redux';
import { RedirectProps } from 'react-router';
import { NavLinkProps } from 'react-router-dom';
import { IState } from '@/state/IState';
import { Breadcrumbs } from '@ygtechnologies/bygr-frontend-component-library';
import { useGetProjectId } from '@/utils/hooks';

const mapStateToProps = (state: IState) =>
    ({
        project: state.global.activeProject,
    }) as { project: any };

type ICommonProps = ReturnType<typeof mapStateToProps> & DispatchProp;

export const ProjectRelativeRedirect = connect(mapStateToProps)(
    ({ project, to, dispatch, ...rest }: ICommonProps & RedirectProps) =>
        project ? <CustomRedirect to={prefixTo(to, `/projects/${project.id}`)} {...rest} /> : null
);

export const ProjectRelativeLink = connect(mapStateToProps)(
    ({ project, to, children, dispatch, ...rest }: ICommonProps & NavLinkProps) => (
        <CustomNavLink to={prefixTo(to, `/projects/${project.id}`)} {...rest}>
            {children}
        </CustomNavLink>
    )
);

export const projectRelativeLink = (to: string, projectId: number | string) => prefixTo(to, `/projects/${projectId}`);

interface BreadcrumbsProjectLinkProps {
    to: string;
    children: React.ReactNode;
}

export const BreadcrumbsProjectLink: React.FC<BreadcrumbsProjectLinkProps> = ({ to, children }) => {
    const projectId = useGetProjectId();
    if (projectId === undefined) return null;
    return <Breadcrumbs.Link to={projectRelativeLink(to, projectId)}>{children}</Breadcrumbs.Link>;
};
